export default "__VITE_ASSET__DGAzLd6$__"